import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import actionJson from './roadMaintenanceImageList.action.json' with { type: 'json' }
import { roadMaintenanceImageObject } from '../roadMaintenanceImageObject'

export const roadMaintenanceImageExpression = expression(roadMaintenanceImageObject.shape)

const roadMaintenanceImageListDefinition = defineAction({
  ...actionJson,

  input: z.object({
    filter: roadMaintenanceImageExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      position: 'Posição',
      id: 'Identificador',
      status: 'Status',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),

  output: z.object({
    items: z.array(roadMaintenanceImageObject),
    count: z.number(),
  }),
})

export default roadMaintenanceImageListDefinition
